import React from 'react'
import { Table, TableHead, TableRow, TableCell } from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';

export default function useTableScroll(headCells) {

    const TblContainer = (props) => (
        <TableContainer  className='table-sm border-table'  style={props.container}>
            <Table className="table table-striped table-hover table-sm">
                {props.children}
            </Table>
        </TableContainer>
    )

    const TblHead = () => {

        return (<TableHead style={{border: 'none'}}>
            <TableRow style={{border: 'none'}}>
                {
                    headCells.map((item, index) => (
                        <TableCell  key={index} style={{ width: item.width, textAlign: item.textAlign,backgroundColor: 'rgba(5, 81, 130, 1)', 
                        position: '-webkit-sticky', position: 'sticky', top: 0,  left: 0, fontWeight: 'bold', 
                        color: '#FFFFFF',fontSize: 14, padding: 5, margin: 0, fontFamily: 'times new roman, times, serif', border: 'none' }}>
                            {item.label}
                        </TableCell>))
                }
            </TableRow>
        </TableHead>)
    }

    return {
        TblContainer,
        TblHead
    }
}




// WEBPACK FOOTER //
// ./src/components/useTableScrollcesar.js